import React from 'react';

import classNames from 'classnames';

import styles from './Spinner.module.css';

export type SpinnerProps = {
  size?: 'small' | 'medium' | 'large';
  dataTestId?: string;
} & React.HTMLAttributes<HTMLSpanElement>;

export const Spinner = ({
  size = 'medium',
  className,
  dataTestId,
}: SpinnerProps) => {
  return (
    <span
      className={classNames(className, styles.spinner, styles[size])}
      data-testid={dataTestId}
    />
  );
};

Spinner.displayName = 'Spinner';
